import { render, staticRenderFns } from "./permission.vue?vue&type=template&id=f3cf595a&scoped=true&"
import script from "./permission.vue?vue&type=script&lang=js&"
export * from "./permission.vue?vue&type=script&lang=js&"
import style0 from "./permission.vue?vue&type=style&index=0&id=f3cf595a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3cf595a",
  null
  
)

export default component.exports